import { useSelector } from 'react-redux'
import getText from '../../i18n/labels'

// FORM
import { BwmCheckbox } from '../BwmCheckboxB5'
import { BwmInput } from '../BwmInputB5'

/**
 * Form per l'editing delle informazioni di contatto (email e flagPec) di un soggetto CORA o CRS.
 *
 * @param {string} nameApplication - Nome dell'applicazione.
 * @param {object} coraSubjectSid - SID CORA.
 * @param {string} defaultEmail - Indirizzo email di default.
 * @param {object} errors - Oggetto degli errori.
 * @param {boolean} disabled - Flag per disabilitare il form.
 * @param {boolean} archived - Flag per disabilitare il form se il soggetto  archiviato.
 * @param {object} sizes - Oggetto che contiene la larghezza che devono avere i campi del form
 * @param {function} handleChangeSid - Funzione che controlla se i campi del sid sono validi e li aggiorna.
 * @param {function} handleChangeSidValues - Funzione per aggiornare i valori del campo sid.
 */
function ContactForm(props) {
  const lang = useSelector((state) => state.language.language)
  const labels = getText(lang)

  // Campo email da mostrare nel form
  let email =
    props.coraSubjectSid?.email || props.coraSubjectSid?.email === ''
      ? props.coraSubjectSid?.email?.toUpperCase()
      : props.defaultEmail
        ? props.defaultEmail?.toUpperCase()
        : ''

  return (
    <div>
      <div className="row">
        <div className={`${props.sizes.email} pe-3`}>
          <div className="form-group">
            {/* Indirizzo email */}
            <BwmInput
              disabled={props.disabled || props.archived}
              className={'form-control'}
              label={`${labels.EMAIL}`}
              name="email"
              placeholder={`${labels.EMAIL_ADDRESS_TO_RECEIVE_GENERATED_FROM} ${props.nameApplication ? props.nameApplication.toUpperCase() : 'CORA'}`}
              error={props.errors?.errorEmail?.msg}
              touched={props.errors?.errorEmail?.isValid === false}
              value={email?.toUpperCase()}
              onChange={(e) =>
                props.handleChangeSid(e, 'errorEmail', labels.INCORRECT_EMAIL_ADDRESS)
              }
            />
          </div>
        </div>
        <div className={`${props.sizes.flagPec} d-flex align-items-center mt-2 mb-1`}>
          {/* Selezionare in caso di email PEC */}
          <BwmCheckbox
            disabled={props.disabled || props.archived}
            name={`flagPec_${props.coraSubjectSid?.id}`}
            label={labels.SELECT_IN_CASE_OF_PEC_EMAIL}
            className="form-control"
            checked={props.coraSubjectSid?.flagPec ? props.coraSubjectSid?.flagPec : false}
            onChange={(e) => props.handleChangeSidValues({ flagPec: e.target.checked })}
          />
        </div>
      </div>
    </div>
  )
}

export default ContactForm
